/**
 * IMPORTANT: This file is only for handling instore module.
 * Other modules are now managed in the merchant-portal project.
 *
 * Authentication is already handled in merchant-portal - the implementation
 * here is legacy only and will be removed in the future.
 * Only URLs will be maintained.
 *
 * Permissions here are only for instore and use legacy permission_scopes.
 * New permissions are in permission_scopes_v2.
 *
 * DO NOT MODIFY localStorage keys - validate if other modules besides instore
 * use them, as these keys are shared across all modules.
 *
 * If you need to modify login auth functionality, please consult with the
 * merchant-services team.
 */

import { whatsNewModalStateItemKey } from '../constants';
import AuthService from '../../services/AuthService';
import { PERSIST_STORE_KEYS } from '../constants';

const Auth = {
  async login(loginData) {
    return await AuthService().logIn(loginData);
  },
  async passwordRecover(recoverData) {
    return await AuthService().passwordRecover(recoverData);
  },
  userLoggedIn() {
    // TODO: Decode and verify JWT
    const { token, employee, stores, merchant } = this.userData();
    return !!(token && employee && stores && merchant);
  },
  saveAuthInfo(data) {
    localStorage.setItem('token', JSON.stringify(data['token']));
    localStorage.setItem('employee', JSON.stringify(data['employee']));
    localStorage.setItem('stores', JSON.stringify(data['stores']));
    localStorage.setItem('merchant', JSON.stringify(data['merchant']));
    localStorage.setItem(
      'permission_scopes',
      JSON.stringify(data['permission_scopes'])
    );
    localStorage.setItem(
      'merchant_structure',
      JSON.stringify(data['merchant_structure'])
    );
  },
  updateAuthData(data) {
    localStorage.removeItem('token');
    localStorage.setItem('token', JSON.stringify(data));
  },
  userData() {
    try {
      return {
        token: JSON.parse(localStorage.getItem('token')),
        employee: JSON.parse(localStorage.getItem('employee')),
        stores: JSON.parse(localStorage.getItem('stores')),
        merchant: JSON.parse(localStorage.getItem('merchant')),
        merchantSelected: JSON.parse(localStorage.getItem('merchantSelected')),
        permission_scopes: JSON.parse(
          localStorage.getItem('permission_scopes')
        ),
        merchant_structure: JSON.parse(
          localStorage.getItem('merchant_structure')
        ),
        tutorial: JSON.parse(localStorage.getItem('tutorial')),
      };
    } catch (_) {
      return {};
    }
  },
  logout() {
    return new Promise((resolve, reject) => {
      try {
        localStorage.removeItem('token');
        localStorage.removeItem('employee');
        localStorage.removeItem('stores');
        localStorage.removeItem('merchant');
        localStorage.removeItem('merchantSelected');
        localStorage.removeItem('permission_scopes');
        localStorage.removeItem('merchant_structure');
        window.localStorage.removeItem('merchant_transactions_report');
        window.localStorage.removeItem('merchant_transactions_report_filters');
        window.localStorage.removeItem('permission_scopes_v2');
        window.localStorage.removeItem('has_merchant_structure');
        window.localStorage.removeItem('merchant-portal-store');
        localStorage.removeItem(whatsNewModalStateItemKey);

        Object.values(PERSIST_STORE_KEYS).forEach(async key => {
          await localStorage.removeItem(key);
        });

        resolve();
      } catch (error) {
        reject(error);
      }
    });
  },
  clearAuthInfo() {},
};

export default Auth;
